const convertPValueToNumber = (PValue) => (PValue === null || PValue === '' ? null : +PValue);
export default convertPValueToNumber;
